import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";

export function InterviewExportButton({ exportToFile, isButtonDisabled }) {
  const fileFormat = { pdf: 1, excel: 0 };
  let { t } = useTranslation();
  const objectRouter = useLocation().pathname;

  return (
    <div className="dropdown">
      <button
        className="app-button btn-second btn-sm"
        type="button"
        id="export"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        disabled={isButtonDisabled}
      >
        {t("Export")}
      </button>
      {(objectRouter === "/interview/advanceSearch" || objectRouter === "/interview/advanceSearchOld") ? (
        <ul className="dropdown-menu dropdown-advance-search-export" aria-labelledby="export">
          <li>
            <a
              className="dropdown-item"
              href="#excel"
              onClick={() => exportToFile(fileFormat.excel)}
            >
              Excel
            </a>
          </li>
        </ul>
      ) : (
        <ul className="dropdown-menu dropdown-interview-export" aria-labelledby="export">
          <li>
            <a
              className="dropdown-item"
              href="#excel"
              onClick={() => exportToFile(fileFormat.excel)}
            >
              Excel
            </a>
          </li>
          <li>
            <a
              className="dropdown-item"
              href="#pdf"
              onClick={() => exportToFile(fileFormat.pdf)}
            >
              Pdf
            </a>
          </li>
        </ul>
      )}
    </div>
  );
}
InterviewExportButton.propTypes = {
  exportToFile: PropTypes.func.isRequired
};